export const contatoOuvidoria = {
    titulo: 'Ouvidoria',
    motivo: 'ouvidoria',
}
export const contatoFaleConosco = {
    titulo: 'Fale Conosco',
    motivo: 'fale-conosco',
}